// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__11eFc","bigColWidth":"Table_bigColWidth__2hb6S","biggerColWidth":"Table_biggerColWidth__3eHY7","row":"Table_row__3hOS7","col":"Table_col__3fxnq"};